import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {
    model: MenuItem[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'Home',
                items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
            },
            {
                label: 'Messaggi',
                icon: 'pi pi-fw pi-globe',
                items: [
                    { label: 'Filtri', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/filters'] },
                    { label: 'Lista mail', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/mail'] },
                    { label: 'Report analisi', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/report'] },
                    { label: 'Analisi', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/analisi']}
                ]
            },
            {
                label: 'Sistema',
                items: [
                    
                    { label: 'Aziende', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/aziende'] },
                    { label: 'Utenti', icon: 'pi pi-fw pi-user', routerLink: ['/app/utenti']},
                    { label: 'Classificazione Mittenti', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/classificazione'] },
                    { label: 'Dem', icon: 'pi pi-fw pi-circle-off', routerLink: ['/app/dem']},
                    { label: 'Domini', icon: 'pi pi-fw pi-pencil', routerLink: ['/app/domini']},
                    { label: 'Classificazioni', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/classificazioni']},
                    { label: 'Termini', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/termini']},
                    { label: 'Modello', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/llmconfig']},
                ]
            },
            {
                label: 'Logs',
                items: [
                    
                    { label: 'Registrazioni', icon: 'pi pi-fw pi-id-card', routerLink: ['/app/logregistrazioni'] },
                    
                    
                ]
            },
            
            
        ];
    }
}
